export default "__VITE_ASSET__44c48adf__"